"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ApplicationAcknowledgementCertificate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="applicationacknowledgementcertificate" className="relative bg-secondary text-secondary-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-primary)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-primary)_1px,transparent_1px)] bg-[size:3rem_3rem] opacity-[0.03] pointer-events-none"></div>

      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="border border-primary/30 p-2 md:p-3 bg-secondary/80 backdrop-blur-md shadow-2xl">
          {}
          <div className="border border-primary/50 p-8 md:p-16 lg:p-24 text-center flex flex-col items-center relative">
            
            {}
            <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-primary/60"></div>
            <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-primary/60"></div>
            <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-primary/60"></div>
            <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-primary/60"></div>

            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/sai_global_logo_light.png" alt="SAI Global" className="h-16 md:h-20 mb-12 object-contain" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/sai_global_logo_light.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/sai_global_logo_light.png-wvc-sizes" />

            {}
            <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-light tracking-tight mb-8 text-secondary-foreground">
              Acknowledgement
              <br />
              of Application
            </h1>

            <p className="text-lg md:text-xl text-secondary-foreground/70 mb-12 max-w-lg mx-auto font-light">
              This may be used as
              <br />
              evidence of the commitment of
            </p>

            {}
            <h2 className="font-default text-3xl md:text-4xl font-medium mb-2 text-secondary-foreground">
              Bottom Up Projects Pty Limited
            </h2>
            <p className="text-sm md:text-base text-secondary-foreground/60 mb-12 tracking-widest uppercase">
              ABN 58 679 003 171
            </p>

            <p className="text-lg md:text-xl italic text-secondary-foreground/70 mb-12 font-serif">
              having applied for
            </p>

            {}
            <div className="font-default text-2xl md:text-3xl lg:text-4xl font-medium leading-snug mb-16 text-secondary-foreground">
              <p>ISO 9001 Quality</p>
              <p>ISO 14001 Environmental</p>
              <p>ISO 45001 Occupational Health & Safety</p>
              <p className="mt-4 text-primary/90">
                Management Systems
                <br />
                Certification
              </p>
            </div>

            {}
            <div className="mb-24">
              <p className="font-mono text-lg md:text-xl text-primary tracking-wider">
                Date Applied: 28/08/2025
              </p>
            </div>

            {}
            <div className="w-full flex flex-col md:flex-row justify-between items-end text-left border-t border-primary/20 pt-8 mt-auto">
              <div className="text-xs md:text-sm text-secondary-foreground/60 space-y-1">
                <p className="font-semibold text-secondary-foreground/90">
                  Rathin Grover
                </p>
                <p>President, Business Assurance</p>
                <p className="font-semibold text-secondary-foreground/90 mt-4">
                  SAI Global Pty Limited
                </p>
                <p>Level 7, Suite 7.01</p>
                <p>45 Clarence Street</p>
                <p>Sydney NSW 2000</p>
                <p>Australia</p>
                <p>Phone 1300 360 314</p>
                <p>ABN 67 050 611 642</p>
                <Link to="https://www.saiassurance.com.au" newTab className="text-primary hover:underline mt-2 inline-block transition-colors">
                  www.saiassurance.com.au
                </Link>
              </div>
              
              {}
              <div className="mt-8 md:mt-0 opacity-30">
                <div className="w-24 h-24 rounded-full border border-primary border-dashed flex items-center justify-center p-1">
                    <div className="w-full h-full rounded-full border border-primary flex items-center justify-center">
                        <span className="text-[10px] uppercase tracking-widest text-primary text-center leading-tight font-mono">
                            Official
                            <br />
                            Seal
                        </span>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}